import { oktaAuth } from "./oktaConfig";
import { LoginCallback, SecureRoute, Security } from "@okta/okta-react";
import { Route, Switch, useHistory } from "react-router-dom";
import React from "react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import config from "../../common/config";

export const Authentication = (props) => {
  const history = useHistory();
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.replace(toRelativeUrl(originalUri || "/", window.location.origin));
  };
  if(config.isLocalTestEnvironment()) {
    return props.children;
  }

  return (
    <Security
      oktaAuth={oktaAuth}
      restoreOriginalUri={restoreOriginalUri}
    >
      <Switch>
        <Route
          path="/login/callback"
          exact
          component={LoginCallback}
        />
        <SecureRoute path="/"> {props.children} </SecureRoute>
      </Switch>
    </Security>
  );
};
